import { PiChatsFill, PiPaperPlaneRightFill, PiImageFill, PiXCircleFill, PiFolderFill, PiFilePdfFill, PiFileZipFill } from 'react-icons/pi';
import type { IconType } from 'react-icons';

// LINEのブランドロゴは既存SVGを使う。
const phosphorIcons: Partial<Record<string, { component: IconType; width: number; height: number; color: string }>> = {
  close: { component: PiXCircleFill, width: 24, height: 24, color: 'var(--color-neutral)' },
  folder: { component: PiFolderFill, width: 20, height: 16, color: 'var(--color-neutral-550)' },
  image: { component: PiImageFill, width: 24, height: 24, color: 'var(--color-neutral)' },
  message: { component: PiChatsFill, width: 25, height: 24, color: 'white' },
  pdf: { component: PiFilePdfFill, width: 24, height: 24, color: 'var(--color-neutral)' },
  zip: { component: PiFileZipFill, width: 24, height: 24, color: 'var(--color-neutral)' },
  sendMessage: { component: PiPaperPlaneRightFill, width: 24, height: 24, color: 'currentColor' },
};

export default phosphorIcons;
